@use '../../styles/mixins.scss' as mixins;
@use '../../styles/surface.scss' as surface;
@use '../../styles/text.scss' as text;
@use '../../styles/border.scss' as border;
@use '../../styles/typography.scss' as typography;

.root {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;

  &.fullWidth {
    width: 100%;
  }
}

.labelRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.labelSuffix {
  @include typography.text-s-regular;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: text.$text-secondary;
}

.label {
  @include typography.text-m-medium;
  display: block;
  color: text.$text-primary;
  cursor: default;

  &.required {
    @include mixins.required-marker;
  }
}

.inputWrapper {
  display: flex;
  align-items: center;
  border-radius: 8px;
  height: 32px;
  padding: 6px 8px;
  box-sizing: border-box;
  transition-property: border-color, background-color, box-shadow;
  transition-duration: 100ms;
  transition-timing-function: ease-out;
  cursor: text;

  &:hover:not(.disabled):not(:focus-within) {
    transition-duration: 150ms;
    transition-timing-function: ease;
  }

  &.standard {
    border: border.$border-width solid border.$border-default;
    background-color: surface.$surface-full;

    &:hover:not(.disabled):not(:focus-within) {
      background-color: surface.$surface-raised;
    }

    &:focus-within:not(.disabled) {
      border-color: border.$border-accent;
    }

    &.error {
      border-color: border.$border-error;
    }
  }

  &.gray {
    border: border.$border-width solid border.$border-muted;
    background-color: surface.$surface-background;

    &:hover:not(.disabled):not(:focus-within) {
      background-color: surface.$surface-hover;
    }

    &:focus-within:not(.disabled) {
      border-color: border.$border-accent;
    }

    &.error {
      border-color: border.$border-error;
    }
  }

  &.borderless {
    border: border.$border-width solid transparent;
    background-color: transparent;
  }

  &.xs {
    height: 24px;
    padding: 4px 6px;

    .input,
    .startAdornment,
    .endAdornment {
      @include typography.text-s-regular;
    }
  }

  &.sm {
    height: 28px;
    padding: 5px 8px;

    .input,
    .startAdornment,
    .endAdornment {
      @include typography.text-s-regular;
    }
  }

  &.disabled {
    @include mixins.disabled(0.4);
  }
}

.input {
  @include typography.text-m-regular;
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: text.$text-primary;
  padding: 0 2px;

  &::placeholder {
    color: text.$text-secondary;
  }

  &:disabled {
    cursor: not-allowed;
  }

  .gray & {
    color: text.$text-secondary;

    &::placeholder {
      color: text.$text-secondary;
    }
  }
}

.startAdornment {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-right: 8px;
  color: text.$text-secondary;

  svg {
    width: 16px;
    height: 16px;
  }
}

.endAdornment {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-left: 8px;
  color: text.$text-secondary;

  svg {
    width: 16px;
    height: 16px;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.helperText {
  @include typography.text-m-regular;
  margin: 0;
  color: text.$text-secondary;

  &.helperTextError {
    color: text.$text-error;
  }
}

.charCount {
  @include typography.text-s-regular;
  color: text.$text-tertiary;
  margin-left: auto;
  flex-shrink: 0;

  &.charCountLimit {
    color: text.$text-error;
  }
}
